<template>
    <Section v-if="questions.length > 0">
        <div 
            v-if="$validateText(data.primary.text)" 
            class="rich-text" 
            v-html="$prismic.asHtml(data.primary.text)" 
        />
        <div class="question-container">
            <div
                v-for="(question, index) in questions" 
                :key="index"
                class="question"
            >
                <nuxt-link :to="question.link" class="question-title">{{ question.title }}</nuxt-link>
                <div v-if="question.author" class="question-author">
                    <prismic-image 
                        :img="question.author.data.image" 
                        :alt="question.author.data.name" 
                        w="30"
                        h="30"
                        class="question-author-avatar" 
                    />
                    <span>
                        {{ $translate('answered_by', 'Svarad av') }}
                        <nuxt-link :to="$prismic.linkResolver(question.author)" class="author-name">{{ question.author.data.name }}</nuxt-link>
                    </span>
                </div>
            </div>
        </div>
    </Section>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            questionsData: []
        };
    },
    async fetch() {
        const ids = this.data.items
            .filter(item => this.$validateContentRelationship(item.question))
            .map(item => item.question.id);
        if (ids.length > 0) {
            this.questionsData = await this.$prismic.api.getByIDs(ids);
        }
    },
    fetchKey() {
        return `user-questions-${this.data.id}`;
    },
    computed: {
        authors() {
            return this.$store.state.authors;
        },
        questions() {
            if (!this.questionsData.results) {
                return [];
            }
            return this.questionsData.results.map(result => {
                return {
                    title: result.data.question_title,
                    author: this.authors[result.data.author.id],
                    link: this.$prismic.linkResolver(result),
                };
            });
        }
    }
};
</script>

<style scoped lang="scss">
section {
    .section-inner {
        @include flex;
        .question-container {
            @include flex(start, start);
            flex-direction: column;
            .question {
                width: 100%;
                @include spacing(padding, 2,(top,bottom));
                @include border(bottom, 1px, #e6e6e6);
                &:last-child {
                    border-bottom: none;
                }
                &-title {
                    display: block;
                    font-weight: bold;
                    color: $green;
                    font-style: italic;
                    @include font-size(18px, 10px);
                    @include spacing(margin,1,bottom);
                    text-decoration: none;
                    &:hover {
                        text-decoration: underline;
                    }
                }
                &-author {
                    @include flex(start, center);
                    @include font-size(16px);
                    color: $font;
                    gap: 0.5rem;
                    &-avatar {
                        border-radius: 50%;
                    }
                    .author-name {
                        color: $font;
                        text-decoration: none;
                        font-weight: bold;
                        &:hover {
                            color: $green;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }
}
</style>